import { createContext } from 'react';
import { ConfirmModalContextType } from './types';

export const ConfirmModalContext = createContext<ConfirmModalContextType>({
  show: () => new Promise(() => {}),
  remove: () => {},
  update: () => '',
});
